import React from 'react'
import RichText from "components/rich-text";
import Image from "components/image";
import { ReactComponent as HoverInfoIcon } from "images/hover-info-icon.svg";
import { ReactComponent as Arrow } from "images/share-arrow.svg";

const components = {
    normal: ({ children }) => (
      <p className="paragraph-normal text-gray-800 xsm:text-base leading-7 mb-5">
        {children}
      </p>
    )
};


const ShareBreakdown = ({ data }) => {
  function getBorderClass(index) {
    let classString = '';
  
    if (data.breakdowns.length - 1 !== index) classString += 'border-solid border-t-0 border-l-0 border-r-0 border-b border-b-[#e8e8e8] ';
    if (data.breakdowns.length - 2 === index) classString += 'border-solid border-t-0 border-l-0 border-r-0 border-b border-b-[#ACACAC] tw-border-solid ';
    return classString.trim();
  }

  return (
    <>
    <div className='flex flex-col'>
        <h2 className='font-display font-bold text-h2 text-green-800 mb-6'> {data.title} </h2>
        <RichText value={data.description.data} components={components} />
        <div className='flex flex-col bg-white rounded'>
            <p className='text-gray-800 mb-2 pt-5 px-5 font-semibold'> THE SHARE PRICE BREAKS DOWN AS FOLLOWS: </p>
            {data.breakdowns?.length > 0 && (
                <div className='relative z-0'>
                  {data.breakdowns.map((breakdown, index) => {
                    return (
                        <div key={breakdown._key} 
                             className={`flex justify-between py-4 px-5 ${getBorderClass(index)}`}>
                            <div className='flex gap-4 items-center'>
                                <div className='w-5 h-5'>
                                    <Image image={breakdown.icon.asset} />
                                </div>
                                <p className='text-gray-800 xsm:text-base leading-7 font-semibold'> {breakdown.title} </p>
                            </div>
                            <div className='flex gap-4 items-center group min-w-[96px] w-24 justify-between'>
                                <button type="button" title="Share Hover Information">
                                    {(breakdown?.hoverTitle && breakdown?.hoverText) && <HoverInfoIcon />}
                                    {(breakdown?.hoverTitle && breakdown?.hoverText) && (
                                      <div className='absolute z-40 w-80 min-h-52 max-h-96 top-[22px] xsm:overflow-y-scroll bg-[#363639] -ml-[340px] py-5 px-6 transition-all duration-300 opacity-0 invisible xsm:-ml-0 xsm:top-1/2 xsm:left-1/2 xsm:transform xsm:-translate-x-1/2 xsm:-translate-y-1/2 group-hover:opacity-100 group-hover:visible group-focus:opacity-100 group-focus:visible group-focus-within:opacity-100 group-focus-within:visible'>
                                        <p className='text-[#F6F6F6] text-left font-bold mb-3'> {breakdown.hoverTitle} </p>
                                        <p className='text-[#F6F6F6] text-left font-medium text-[0.938rem]'> {breakdown.hoverText} </p>
                                      </div>
                                      )}
                                </button>
                                <p className='text-gray-800 font-semibold'> £{breakdown.price} </p>
                                {(breakdown?.hoverTitle && breakdown?.hoverText) && <Arrow className='absolute -ml-[20px] opacity-0 invisible duration-300 xsm:hidden flex group-hover:opacity-100 group-hover:visible' /> }
                            </div>
                        </div>
                    )
                  })}
                </div>
            )}
        </div>
    </div>
    <div className='h-px w-full bg-gray-300 my-8' />
    </>
  )
}

export default ShareBreakdown